import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfiguratorComponent } from './configurator/configurator.component';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration} from '@angular/common/http';
import { TooltipDirective } from './tooltip.directive';
import { OptionComponent } from './option/option.component';
import { HomeComponent } from './home/home.component';
import { ItemSearchComponent } from './home/item-search/item-search.component';
import { ConfigurationsComponent } from './configurations/configurations.component';
import { GenerateDocComponent } from './generate-doc/generate-doc.component';
import { HomeService } from './home/home.service';

@NgModule({
  declarations: [
    AppComponent,
    ConfiguratorComponent,
    TooltipDirective,
    OptionComponent,
    HomeComponent,
    ItemSearchComponent,
    ConfigurationsComponent,
    GenerateDocComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule
  ],
  providers: [provideHttpClient(
              withInterceptorsFromDi(), 
              withXsrfConfiguration( { cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' })),
              HomeService
          ],
  bootstrap: [AppComponent]
})
export class AppModule { }
